var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { class: _vm.slideInClass }, [
        _c("header", { staticClass: "titled" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "close-container" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.closeFan.apply(null, arguments)
                  }
                }
              },
              [_c("Icon", { attrs: { icon: "close" } })],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "main",
          { staticClass: "scrollbar-check" },
          [
            _c("h2", [_vm._v(_vm._s(_vm.applicantName))]),
            _vm._v(" "),
            _vm.hasBothPermissions
              ? [
                  _c("div", { staticClass: "mb-3" }, [
                    _vm._v(
                      "\n\t\t\t\tSoll die Person nur für diesen Job oder auch für weitere/künftige Jobs ausgeschlossen werden?\n\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("RadioGroup", {
                    attrs: { options: _vm.exclusionTypeOptions, stacked: "" },
                    model: {
                      value: _vm.exclusionType,
                      callback: function($$v) {
                        _vm.exclusionType = $$v
                      },
                      expression: "exclusionType"
                    }
                  })
                ]
              : [
                  _vm.permissionJobProfile
                    ? _c("div", [
                        _vm._v(
                          "\n\t\t\t\tSoll die Person wirklich für diesen Job ausgeschlossen werden?\n\t\t\t"
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.permissionComprehensive
                    ? _c("div", [
                        _vm._v(
                          "\n\t\t\t\tSoll die Person wirklich für alle Jobs ausgeschlossen werden?\n\t\t\t"
                        )
                      ])
                    : _vm._e()
                ]
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "footer",
          [
            _c("Button", {
              attrs: {
                text: "Kandidat ausschließen",
                icon: "checkmark",
                disabled: !_vm.dataValid || _vm.saving,
                loading: _vm.saving
              },
              on: { click: _vm.exclude }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("h1", [_vm._v("Kandidat ausschließen")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }